"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcademyListTitle = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../common");
const SearchInput_1 = require("../ui/SearchInput");
exports.AcademyListTitle = react_1.default.memo(({ searchOption, setSearchOption, }) => {
    const onRegistAcademy = () => {
        APP.eventManager.publish('CHANGE_MENU', {
            showDepth: 'regist',
            props: {},
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(common_1.Button, { className: "btn-round btn-peach btn-xmd", text: "\uD559\uC6D0 \uB4F1\uB85D", onClick: onRegistAcademy }),
        react_1.default.createElement(SearchInput_1.SearchInput, { defaultValue: searchOption, setSearchOption: setSearchOption })));
});
